"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupRemoveMemberModal = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _service = require("./service");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GroupRemoveMemberModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupRemoveMemberModal, _Component);

  var _super = _createSuper(GroupRemoveMemberModal);

  function GroupRemoveMemberModal() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupRemoveMemberModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      removingMember: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeMember", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props, groupId, memberId, _this$props$showMessa, _this$props2, _this$props$showMessa2, _this$props3;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, groupId = _this$props.groupId, memberId = _this$props.memberId;

              if (memberId) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _this.setState({
                removingMember: true
              });

              _context.prev = 4;
              _context.next = 7;
              return (0, _service.removeMember)({
                groupId: groupId,
                data: {
                  userIds: [+memberId]
                }
              });

            case 7:
              (_this$props$showMessa = (_this$props2 = _this.props).showMessage) === null || _this$props$showMessa === void 0 ? void 0 : _this$props$showMessa.call(_this$props2, 'success', (0, _preact.h)(_phrase.default, {
                p: "groups.remove.user.removed"
              }));

              _this.props.onRemove();

              _this.props.onClose();

              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              (_this$props$showMessa2 = (_this$props3 = _this.props).showMessage) === null || _this$props$showMessa2 === void 0 ? void 0 : _this$props$showMessa2.call(_this$props3, 'error', _context.t0);

            case 15:
              _context.prev = 15;

              _this.setState({
                removingMember: false
              });

              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 12, 15, 18]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(GroupRemoveMemberModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var removingMember = this.state.removingMember;
      var _this$props4 = this.props,
          onClose = _this$props4.onClose,
          groupTitle = _this$props4.groupTitle;
      return (0, _preact.h)(_modal.default, {
        customClass: "group-remove-member-modal"
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
          p: "groups.remove.user.title"
        }))
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)("div", {
        className: "groups-remove-member-modal"
      }, (0, _preact.h)("div", {
        className: "remove-member-modal_description"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.remove.user.description",
        count: {
          group: groupTitle
        }
      })))), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        size: "medium",
        className: "remove-member-modal_cancel-btn",
        onClick: onClose,
        isLoading: removingMember
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.cancel"
      })), (0, _preact.h)(_Button.default, {
        size: "medium",
        className: "remove-member-modal_add-btn",
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.removeMember();

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })),
        isLoading: removingMember,
        "data-bounded-context": "Groups",
        "data-entity": "group-remove-member",
        "data-track-type": "click",
        "data-element-name": "Group Clicked remove member"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.remove"
      }))));
    }
  }]);
  return GroupRemoveMemberModal;
}(_preact.Component);

exports.GroupRemoveMemberModal = GroupRemoveMemberModal;
var _default = GroupRemoveMemberModal;
exports.default = _default;